import { Box, Divider, Tooltip, Button } from '@mui/material'
import styled from 'styled-components'
import { ChartType, MetricValue, Ranking, ViewType } from 'types'
import { COLOR } from 'constant'

export interface ILeftPanelSection {
  children: React.ReactNode
  header?: string
  subheader?: string
  isTooltip?: boolean
  tooltip1?: string
  tooltip2?: string
}
export const LeftPanelPillarSelector: React.FC<ILeftPanelSection> = ({
  children,
  header,
  subheader,
  isTooltip = false,
  tooltip1 = 'Tooltip Content',
  tooltip2 = 'Tooltip Content',
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '16px' }}>
      <Box sx={{ display: 'flex', gap: { xs: '90px', sm: '90px' } }}>
        <Box>
          <Header style={{ marginRight: '4px', fontFamily: 'CircularStdBook' }}>{header}</Header>
          {isTooltip && <TooltipComponent iconColor={COLOR.DARK} content={tooltip1} />}
        </Box>
        <Box>
          <Header style={{ marginRight: '4px', fontFamily: 'CircularStdBook' }}>{subheader}</Header>
          {isTooltip && <TooltipComponent iconColor={COLOR.DARK} content={tooltip2} />}
        </Box>
      </Box>
      <Divider sx={{ width: { xs: '80%', sm: '65%' }, marginTop: '4px', borderColor: '#498abf' }} />
      {children}
    </Box>
  )
}
export const LeftPanelSection: React.FC<ILeftPanelSection> = ({
  children,
  header,
  isTooltip = false,
  tooltip1 = 'Tooltip Content',
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '16px' }}>
      <Box>
        <Header style={{ marginRight: '4px', fontFamily: 'CircularStdBook' }}>{header}</Header>
        {isTooltip && <TooltipComponent iconColor={COLOR.DARK} content={tooltip1} />}
      </Box>
      <Divider sx={{ width: '65%', marginTop: '4px', borderColor: '#498abf' }} />
      {children}
    </Box>
  )
}

export interface ITooltip {
  iconColor: string
  content: string
  position?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
  isArrow?: boolean
}
export const TooltipComponent: React.FC<ITooltip> = ({ content, position = 'top', iconColor, isArrow = false }) => {
  return (
    <Tooltip
      title={content}
      arrow={isArrow}
      placement={position}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -8],
              },
            },
          ],
        },
      }}
    >
      <Button sx={{ minWidth: '14px', p: 0 }}>
        <SvgInfoIcon iconColor={iconColor} width='12px' height='12px' />
      </Button>
    </Tooltip>
  )
}
export const RoundButton = styled.button`
  display: flex;
  padding: 11px 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  min-width: 132px;
  background: ${COLOR.LIGHT});
`

export const RoundedButtonFullWidth = styled(RoundButton)`
  min-width: 160px;
  font-size: 14px;
  height: 32px;
  line-height: 1;
  @media (max-width: 480px) {
    min-width: 116px;
    font-size: 12px;
  }
`
export const RoundedButtonStatic = styled(RoundButton)`
  background: ${COLOR.DARK};
  color: ${COLOR.TEXT};
  min-width: 118px;
  height: 26px;
  font-size: 12px;
  line-height: 1;
`
export const RoundedButtonStaticNodata = styled(RoundButton)`
  background: ${COLOR.LIGHT};
  color: ${COLOR.DARK};
  min-width: 118px;
  height: 26px;
  font-size: 12px;
`
// btn dark: bgbtn: DARK, text: TEXT
// btn light: bgbtn: LIGHT, text: NAVY
export const RoundButtonMetricValue = styled(RoundButton)<{
  type: MetricValue
  $currentType: MetricValue
  $isBorder?: boolean
}>`
  background: ${(props) => (props.type === props.$currentType ? COLOR.DARK : COLOR.LIGHT)};
  color: ${(props) => (props.type === props.$currentType ? COLOR.TEXT : COLOR.NAVY)};
  border: ${(props) => (props.$isBorder ? `1px solid ${COLOR.DARK}` : 'unset')};
  font-size: 14px !important;
`
export const RoundButtonChartTypeATMOT = styled(RoundButton)<{
  $chartType: ChartType
  $currentType: ChartType
  $isBorder?: boolean
}>`
  background: ${(props) => (props.$chartType === props.$currentType ? COLOR.DARK : COLOR.LIGHT)};
  color: ${(props) => (props.$chartType === props.$currentType ? COLOR.TEXT : COLOR.NAVY)};
  border: ${(props) => (props.$isBorder ? `1px solid ${COLOR.DARK}` : 'unset')};
  font-size: 14px !important;
`
export const RoundButtonATMOT = styled(RoundButton)<{
  $type: MetricValue
  $currentType: MetricValue
  $isBorder?: boolean
}>`
  background: ${(props) => (props.$type === props.$currentType ? COLOR.DARK : COLOR.LIGHT)};
  color: ${(props) => (props.$type === props.$currentType ? COLOR.TEXT : COLOR.NAVY)};
  border: ${(props) => (props.$isBorder ? `1px solid ${COLOR.DARK}` : 'unset')};
  font-size: 14px !important;
`
export const RowSelectPillar = styled.div`
  display: flex;
  gap: 20px;
`
export const RowExpandSelectPillar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 20px;
  margin-top: 12px;
`
export const RowSelectSubPillar = styled(RowSelectPillar)`
  display: flex;
  flex-direction: column;
  gap: 0px;
`
export const PillarSelectButton = styled(RoundButton)`
  height: 32px;
  padding: 8px 8px;
  border: 1px solid #051b33;
  background: #fff;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  min-width: 150px;
  @media (max-width: 480px) {
    min-width: 126px;
    font-size: 11px;
  }
`

export const SubIndexSelectButton = styled(RoundButton)`
  height: 32px;
  padding: 8px 8px;
  border: 1px solid #051b33;
  background: #fff;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  min-width: 150px;
  @media (max-width: 480px) {
    min-width: 126px;
    font-size: 11px;
  }
`

export const CornerButton = styled(RoundButton)`
  border-radius: 6px;
  position: relative;
  min-width: 128px;
  padding: 10px 10px;
  & svg: {
    width: 16px;
    height: 16px;
    fill: red;
  }
  font-size: 14px;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`
export const CornerButtonTools = styled(CornerButton)`
  font-size: 16px;
  @media (max-width: 480px) {
    font-size: 14px;
  }
`
// btn dark: bgbtn: DARK, text: TEXT
// btn light: bgbtn: LIGHT, text: NAVY
export const CornerButtonViewType = styled(CornerButton)<{
  $customType: ViewType
  $currentType: ViewType
  disabled?: boolean
}>`
  background: ${(props) => (props.$customType === props.$currentType ? COLOR.DARK : COLOR.LIGHT)};
  color: ${(props) =>
    !props.disabled
      ? props.$customType === props.$currentType
        ? COLOR.TEXT
        : COLOR.NAVY
      : props.$customType !== props.$currentType
      ? 'gray'
      : 'rgba(115,217,255,0.6)'};
`
export const CornerButtonRanking = styled(CornerButton)<{ value: Ranking; currentValue: Ranking }>`
  background: ${(props) => (props.value === props.currentValue ? COLOR.DARK : COLOR.LIGHT)};
  color: ${(props) => (props.value === props.currentValue ? COLOR.TEXT : COLOR.NAVY)};
`

export const Header = styled.span`
  font-size: 14px;
  color: #041b33;
  font-weight: 400;
  margin-bottom: 4px;
`
export const SvgInfoIcon = ({ iconColor, width, height }: { iconColor: string; width?: string; height?: string }) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill={iconColor} viewBox='0 0 32 32' width={width} height={height}>
    <path d='M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z' />
  </svg>
)
export const SvgCarretDownIcon = ({
  iconColor,
  width,
  height,
}: {
  iconColor: string
  width?: string
  height?: string
}) => {
  return (
    <svg width={width} height={height} viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M128,188a11.96187,11.96187,0,0,1-8.48535-3.51465l-80-80a12.0001,12.0001,0,0,1,16.9707-16.9707L128,159.0293l71.51465-71.51465a12.0001,12.0001,0,0,1,16.9707,16.9707l-80,80A11.96187,11.96187,0,0,1,128,188Z'
        style={{ fill: iconColor }}
      />
    </svg>
  )
}
export const SvgCarretLeftIcon = ({
  iconColor,
  width,
  height,
}: {
  iconColor: string
  width?: string
  height?: string
}) => {
  return (
    <svg width={width} height={height} viewBox='9 7 6 10' fill={iconColor} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.0303 7.46967C14.3232 7.76256 14.3232 8.23744 14.0303 8.53033L10.5607 12L14.0303 15.4697C14.3232 15.7626 14.3232 16.2374 14.0303 16.5303C13.7374 16.8232 13.2626 16.8232 12.9697 16.5303L8.96967 12.5303C8.67678 12.2374 8.67678 11.7626 8.96967 11.4697L12.9697 7.46967C13.2626 7.17678 13.7374 7.17678 14.0303 7.46967Z'
        fill={iconColor}
      />
    </svg>
  )
}
